import React, { memo } from 'react'

export const Globe = memo(() => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110 110">
      <path
        d="M99.239 23.116a.913.913 0 00-.012-.106c-.137-.2-.3-.363-.445-.555q-1.531-2.086-3.242-4.016c-.312-.352-.625-.7-.945-1.043q-1.762-1.887-3.7-3.6c-.238-.211-.461-.43-.7-.637a54.753 54.753 0 00-10.368-7c-.149-.078-.3-.144-.457-.223a54.329 54.329 0 00-5.079-2.262c-.391-.141-.746-.274-1.117-.391q-2.309-.832-4.688-1.457c-.469-.125-.938-.254-1.414-.363a53.687 53.687 0 00-4.719-.861c-.484-.07-.961-.164-1.449-.223a51.357 51.357 0 00-12.392 0c-.488.059-.965.152-1.449.223-1.6.227-3.176.5-4.723.867-.477.109-.945.238-1.414.363q-2.395.625-4.688 1.457c-.391.133-.746.266-1.117.391a54.3 54.3 0 00-5.079 2.262c-.152.078-.309.144-.457.223a54.766 54.766 0 00-10.4 7c-.238.207-.461.426-.7.637a50.81 50.81 0 00-3.7 3.6c-.32.344-.633.692-.945 1.043q-1.715 1.926-3.242 4.016c-.141.191-.309.359-.445.555a.887.887 0 00-.047.106 54.336 54.336 0 000 63.122.851.851 0 00.047.106c.137.2.3.363.445.555q1.528 2.086 3.242 4.016c.312.352.625.7.945 1.043q1.766 1.887 3.7 3.6c.238.211.461.43.7.637a54.752 54.752 0 0010.368 7c.149.078.3.144.457.223a54.328 54.328 0 005.079 2.262c.391.141.746.274 1.117.391q2.309.832 4.688 1.457c.469.125.938.254 1.414.363 1.563.363 3.125.641 4.723.867.484.07.961.164 1.449.223a51.358 51.358 0 0012.392 0c.488-.059.965-.152 1.449-.223 1.6-.227 3.176-.5 4.723-.867.477-.109.945-.238 1.414-.363q2.4-.625 4.688-1.457c.391-.133.746-.266 1.117-.391a54.3 54.3 0 005.079-2.262c.152-.078.309-.144.457-.223a54.762 54.762 0 0010.368-7c.238-.207.461-.426.7-.637a49.735 49.735 0 003.7-3.6c.32-.344.633-.692.945-1.043q1.715-1.93 3.242-4.016c.141-.191.309-.359.445-.555a.884.884 0 00.047-.106 54.336 54.336 0 00-.007-63.128zm-4.455 7.391a46.483 46.483 0 016.59 20.263h-23.4a72.9 72.9 0 00-2.19-13.786 70.2 70.2 0 0019-6.477zM64.631 8.876c.219.051.43.121.648.172a42.041 42.041 0 014.141 1.172c.207.07.41.152.613.227q2.016.7 3.965 1.563c.227.106.449.223.676.328q1.863.887 3.641 1.918l.781.473q1.688 1.031 3.282 2.207c.274.2.547.391.816.609a35.644 35.644 0 012.99 2.512c.25.227.508.449.754.684 1 .949 1.953 1.953 2.875 2.992.117.137.242.262.359.391a65.528 65.528 0 01-16.661 5.352A99.334 99.334 0 0062.998 8.607c.543.095 1.098.152 1.633.269zM39.207 50.77a65.182 65.182 0 012.149-12.5 111.942 111.942 0 0013.337.781 112.2 112.2 0 0013.349-.8 65.061 65.061 0 012.137 12.521zm30.971 7.813a65.182 65.182 0 01-2.149 12.5 114.334 114.334 0 00-26.686 0 65.079 65.079 0 01-2.137-12.5zM54.692 10.345a94.353 94.353 0 0110.892 20.314 103.4 103.4 0 01-10.888.578 104.177 104.177 0 01-10.876-.582 95.1 95.1 0 0110.872-20.31zm-35.12 13.384a47.265 47.265 0 012.875-2.992c.246-.234.5-.457.754-.684q1.446-1.316 2.992-2.512c.27-.207.543-.391.816-.609q1.594-1.172 3.282-2.207l.781-.473q1.778-1.039 3.641-1.918c.227-.106.449-.223.676-.328q1.945-.879 3.965-1.563c.2-.074.391-.156.613-.227a52.123 52.123 0 014.141-1.172c.219-.051.43-.121.652-.168.535-.117 1.09-.172 1.633-.27a99.34 99.34 0 00-10.519 20.873 65.525 65.525 0 01-16.661-5.352c.117-.136.242-.261.359-.398zm-4.969 6.778a70.187 70.187 0 0018.994 6.477 72.9 72.9 0 00-2.184 13.786h-23.4a46.489 46.489 0 016.59-20.263zm0 48.34a46.484 46.484 0 01-6.59-20.263h23.4a72.9 72.9 0 002.188 13.786 70.184 70.184 0 00-18.998 6.477zm30.151 21.63c-.219-.051-.43-.121-.648-.172a42.039 42.039 0 01-4.141-1.172c-.207-.07-.41-.152-.613-.227q-2.016-.7-3.965-1.563c-.227-.106-.449-.223-.676-.328q-1.863-.887-3.641-1.918l-.781-.473q-1.688-1.031-3.282-2.207c-.274-.2-.547-.391-.816-.609a35.643 35.643 0 01-2.992-2.512c-.25-.227-.508-.449-.754-.684-1-.949-1.953-1.953-2.875-2.992-.117-.137-.242-.262-.359-.391a65.528 65.528 0 0116.661-5.352 99.333 99.333 0 0010.512 20.87c-.54-.098-1.095-.152-1.63-.27zm9.938-1.469a94.353 94.353 0 01-10.887-20.314 101.7 101.7 0 0121.767 0 95.076 95.076 0 01-10.88 20.314zm35.12-13.384a47.265 47.265 0 01-2.875 2.992c-.246.234-.5.457-.754.684q-1.446 1.321-2.992 2.512c-.27.207-.543.41-.816.609q-1.594 1.172-3.282 2.207l-.781.473q-1.774 1.035-3.641 1.918c-.227.106-.449.223-.676.328q-1.945.879-3.965 1.563c-.2.074-.391.156-.613.227a52.123 52.123 0 01-4.141 1.172c-.219.051-.43.121-.652.168-.535.117-1.09.172-1.633.27a99.322 99.322 0 0010.515-20.869 65.526 65.526 0 0116.661 5.352c-.112.133-.237.258-.355.394zm4.972-6.777a70.187 70.187 0 00-19-6.477 72.9 72.9 0 002.184-13.786h23.4a46.491 46.491 0 01-6.584 20.263z"
        transform="translate(-.017 .002) translate(.016 -.002)"
      ></path>
    </svg>
  )
})

export const DownArrow = memo(() => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 15'>
      <g transform='rotate(-90 34.125 34.126)'>
        <path d='M54.489 13.755L66.034 25.3a1.3 1.3 0 001.835-1.832L57.24 12.839 67.869 2.213A1.3 1.3 0 0066.033.38L54.487 11.922a1.308 1.308 0 00.002 1.833z'></path>
      </g>
    </svg>
  )
})

export const NextArrow = memo(() => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14.314 20.042'>
      <path d='M13.093 12.378l-5.22 5.22V.716a.716.716 0 10-1.432 0v16.882l-5.22-5.22A.716.716 0 00.209 13.39l6.442 6.442a.716.716 0 001.012 0l6.442-6.442a.716.716 0 10-1.012-1.012z' />
    </svg>
  )
})

export const ServiceOne = memo(() => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 42.186 71.912'>
      <g>
        <path
          fill='#ffa700'
          d='M.5 35.668l20.593 11.889 20.593-11.889V11.889L21.093 0 .5 11.889z'></path>
        <path
          fill='none'
          stroke='#fff'
          strokeMiterlimit='10'
          d='M.5 59.446l20.593 11.889 20.593-11.889V35.667L21.093 23.778.5 35.667z'></path>
      </g>
    </svg>
  )
})

export const ServiceTwo = memo(() => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56 56'>
      <g stroke='#fff'>
        <g fill='none' data-name='stroke'>
          <circle cx='28' cy='28' r='28' stroke='none'></circle>
          <circle cx='28' cy='28' r='27'></circle>
        </g>
        <g data-name='fill' transform='translate(10 10)'>
          <circle cx='18' cy='18' r='18' stroke='none'></circle>
          <circle cx='18' cy='18' r='17' fill='none'></circle>
        </g>
      </g>
    </svg>
  )
})

export const LinkedIn = memo(() => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22.949 22.949'>
      <path d='M21.294 0H1.655A1.655 1.655 0 000 1.655v19.639a1.655 1.655 0 001.655 1.655h19.639a1.655 1.655 0 001.655-1.655V1.655A1.655 1.655 0 0021.294 0zM8.14 17.346H5.346V8.939H8.14zM6.74 7.79h-.015a1.457 1.457 0 11.037-2.905 1.457 1.457 0 11-.019 2.905zm11.474 9.556h-2.791v-4.5c0-1.13-.4-1.9-1.416-1.9a1.53 1.53 0 00-1.434 1.022 1.914 1.914 0 00-.092.682v4.7H9.687s.037-7.619 0-8.408h2.794v1.19A2.774 2.774 0 0115 8.741c1.839 0 3.217 1.2 3.217 3.784zm0 0'></path>
    </svg>
  )
})

export const Facebook = memo(() => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 23.182 23.067'>
      <path d='M20.183 0h-17.3A2.855 2.855 0 000 2.883v17.3a2.855 2.855 0 002.883 2.883h8.65v-7.957H8.65v-3.576h2.883V8.65a4.381 4.381 0 014.383-4.383H18.8v3.576h-1.5c-.807 0-1.384-.115-1.384.692v2.883h3.575l-1.384 3.575h-2.191v7.958H20.3a2.855 2.855 0 002.883-2.883V2.883a3.031 3.031 0 00-3-2.883z'></path>
    </svg>
  )
})

export const Instagram = memo(() => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 26'>
      <path
        strokeWidth='2'
        d='M24.067 7.228v10.611a6.2 6.2 0 01-6.228 6.228H7.228A6.2 6.2 0 011 17.839V7.228A6.2 6.2 0 017.228 1h10.611a6.2 6.2 0 016.228 6.228z'></path>
      <path
        data-name='inner'
        d='M12.533 6.19a6.343 6.343 0 106.343 6.343 6.4 6.4 0 00-6.343-6.343zm0 11.3a4.959 4.959 0 114.957-4.957 4.923 4.923 0 01-4.957 4.957z'></path>
      <path
        data-name='outer'
        d='M18.992 4.691a1.09 1.09 0 00-1.153 1.153 1.153 1.153 0 002.307 0 1.09 1.09 0 00-1.154-1.153z'></path>
    </svg>
  )
})

export const Mail = memo(() => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="m230.9 253.371c13.369 8.913 36.827 8.914 50.199-.001.002-.001.005-.003.007-.004l227.865-151.911c-7.474-21.616-28.018-37.188-52.142-37.188h-401.663c-24.125 0-44.668 15.572-52.143 37.188l227.87 151.912c.003.002.005.002.007.004z"/><path d="m297.746 278.328c-.003.002-.005.004-.007.005-11.702 7.801-26.724 11.702-41.741 11.702-15.02 0-30.036-3.9-41.739-11.703-.002-.001-.003-.002-.005-.003l-214.254-142.835v257.072c0 30.417 24.747 55.163 55.166 55.163h401.666c30.418 0 55.164-24.746 55.164-55.163v-257.072z"/></svg>
  )
})

export const Twitter = memo(() => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 28 23'>
      <path d='M27.449 2.656a10.639 10.639 0 01-3.21.885 5.725 5.725 0 002.435-3.1 10.6 10.6 0 01-3.542 1.328A5.422 5.422 0 0019.037 0 5.55 5.55 0 0013.5 5.534a5.388 5.388 0 00.111 1.328A15.674 15.674 0 012.1 1a6.574 6.574 0 00-.775 2.878A5.761 5.761 0 003.76 8.527a6.672 6.672 0 01-2.546-.664v.111a5.6 5.6 0 004.427 5.534 6.478 6.478 0 01-1.439.221 4.152 4.152 0 01-1.107-.111 5.587 5.587 0 005.2 3.874 11.563 11.563 0 01-6.973 2.435 5.389 5.389 0 01-1.328-.111 16.056 16.056 0 008.523 2.546A15.828 15.828 0 0024.461 6.42v-.775a9.62 9.62 0 002.988-2.989z'></path>
    </svg>
  )
})

export const Location = memo(() => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 18'>
      <path
        d='M6.519 0A6.526 6.526 0 000 6.519c0 4.461 5.834 11.01 6.082 11.286a.587.587 0 00.873 0c.248-.277 6.082-6.825 6.082-11.286A6.526 6.526 0 006.519 0zm0 9.8a3.28 3.28 0 113.28-3.28 3.284 3.284 0 01-3.28 3.28z'></path>
    </svg>
  )
})

export const Close = memo(() => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'>
      <path
        d='M11.475.138a.469.469 0 00-.663 0L.138 10.812a.469.469 0 10.663.663L11.475.8a.469.469 0 000-.662z'></path>
      <path
        d='M11.475 10.812L.8.138a.469.469 0 00-.662.661l10.674 10.676a.469.469 0 10.663-.663z'></path>
    </svg>
  )
})

export const Circle = memo(() => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 67 67'>
      <defs>
        <clipPath id='circlepath'>
          <path d='M0 0h67v67H0z'></path>
        </clipPath>
      </defs>
      <g
        clipPath={`url(${window.location.protocol}//${window.location.host}${window.location.pathname}#circlepath)`}>
        <path
          fill='none'
          stroke='#fff'
          strokeWidth='3'
          d='M33.532 1.859A31.616 31.616 0 111.909 33.475 31.619 31.619 0 0133.532 1.859z'></path>
      </g>
    </svg>
  )
})

export const BackArrow = memo(() => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 20'>
      <path
        d='M10.222 17.465L3.259 10.5h22.518a.955.955 0 000-1.91H3.259l6.963-6.96A.955.955 0 008.872.28L.279 8.873a.955.955 0 000 1.35l8.593 8.593a.955.955 0 101.35-1.35z'></path>
    </svg>
  )
})

export const LogoWhite = memo(() => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 81 81'>
      <g transform='translate(-237.751 -715.76)'>
        <circle
          cx='40.5'
          cy='40.5'
          r='40.5'
          fill='none'
          transform='translate(237.751 715.76)'></circle>
        <g fill='#fff'>
          <path
            d='M307.118 765.243a4.651 4.651 0 00-4.636-.571 29.53 29.53 0 001.257-7.218 13.9 13.9 0 00-5.008-9.068c-.685 18.332-16.173 27.084-18.957 28.512a19.374 19.374 0 01-9.3 2.374 19.611 19.611 0 01-2.221-.128c10.783 5.366 25.848-.037 30.585-6.85.386-.557.743-1.138 1.089-1.73a4.646 4.646 0 008.068 1.214 4.664 4.664 0 00-.877-6.535z'></path>
          <path
            d='M264.38 776.707a18.161 18.161 0 0013.283-.466c-4.63-2.64-17.952-11.792-17.837-29.633a22.158 22.158 0 011.323-8.246c-6.691 7.159-7.929 17.52-5.1 26.215a4.674 4.674 0 102.794 6.042q.614.979 1.312 1.895a22.15 22.15 0 004.225 4.193z'></path>
          <path
            d='M303.459 751.653a24.292 24.292 0 00-7.749-14.623 23.031 23.031 0 00-13.417-6.348 4.673 4.673 0 10-6.6-.663 4.524 4.524 0 00.665.668 24.539 24.539 0 00-11.41 4.407c-2.743 2.833-3.427 7.121-3.564 9.839a20.614 20.614 0 016.293-3.775 29.737 29.737 0 0111.643-2.3 28.1 28.1 0 0110.944 2.235 33.314 33.314 0 017.753 4.807 17.921 17.921 0 015.442 5.753z'></path>
        </g>
      </g>
    </svg>
  )
})

export const Triangle = memo(() => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 67 111'>
      <g fill='#fff'>
        <path
          d='M693.45 487.504v110.974h-33.233z'
          transform='translate(-660.217 -487.504)'
        ></path>
        <path
          d='M693.45 487.504v110.974h33.234z'
          opacity='0.405'
          transform='translate(-660.217 -487.504)'
        ></path>
      </g>
    </svg>
  )
})